import { useQuery } from "react-query";
import { getJobConfigReport } from "../../../../actions/Utilities/JobConfig";

const useGetJobConfigReport = (args) => {
  return useQuery(["JobConfigReport", args], () => getJobConfigReport(args), {
    refetchOnWindowFocus: false,
  });
};

export default useGetJobConfigReport;
